/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React from 'react';
import PropTypes from 'prop-types';
import Screen from '../Screen';
import Attributeview from '../../Attributeview/Attributeview';
import './Attrib.css';

/**
 * Represents the attribute maintenance screen.
 */

export default class Attrib extends Screen {

    /**
     * Properties.
     */

    static propTypes = {
        attribute:              PropTypes.object,
        onBack:                 PropTypes.func.isRequired
    }

    /** 
     * Event that fires when the screen mounted.
     */

    componentDidMount() {

        // Setting actionbar title

        this.props.onSetActionbarTitle(
            this.props.attribute ? 
            this.props.context.locale.attribute.title.modifyattribute :
            this.props.context.locale.attribute.title.newattribute
        );
    }

    /** 
     * Attribute maintenance screen renderer.
     */

    render() {
        return (
            <div className="attrib" style={{ height: this.props.context.environment.screen.usefullheight + 'px'}}>

                {/* Attribute container */}

                <div className="attrib-container">

                {/* Attribute maintenance */}

                    <Attributeview context={this.props.context} attribute={this.props.attribute} onClose={this.props.onBack} onLoading={this.props.onLoading} />
                </div>               
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/Attrib/Attrib.js